import { Haptics, ImpactStyle } from '@capacitor/haptics';

// Check if we're in a Capacitor native context
const isNative = typeof (window as any).Capacitor !== 'undefined';

export async function hapticLight() {
  try {
    if (isNative) {
      await Haptics.impact({ style: ImpactStyle.Light });
    } else if (navigator.vibrate) {
      navigator.vibrate(10);
    }
  } catch {
    // Silently fail if haptics unavailable
  }
}

export async function hapticMedium() {
  try {
    if (isNative) {
      await Haptics.impact({ style: ImpactStyle.Medium });
    } else if (navigator.vibrate) {
      navigator.vibrate(25);
    }
  } catch {
    // Silently fail if haptics unavailable
  }
}

export async function hapticHeavy() {
  try {
    if (isNative) {
      await Haptics.impact({ style: ImpactStyle.Heavy });
    } else if (navigator.vibrate) {
      navigator.vibrate(50);
    }
  } catch {
    // Silently fail if haptics unavailable
  }
}
